import { AgentPriceWebService } from '@linktivity/gds-neo';
import config from '../config';

const agentPriceApi = new AgentPriceWebService.PriceWebServiceApi(config);

export default agentPriceApi;
